import { useState } from 'react';
import { exportRowsToExcel } from '../utils/exportExcel.js';
import { t } from '../i18n/index.jsx';
import { useToast } from './feedback.jsx';

/** Small toolbar button that exports `rows` with `columns` to .xlsx */
export default function ExportButton({ filename, rows, columns, disabled }) {
  const toast = useToast();
  const [busy, setBusy] = useState(false);

  async function onClick() {
    if (!rows?.length) {
      toast(t('Nothing to export'), { tone: 'info' });
      return;
    }
    setBusy(true);
    try {
      await exportRowsToExcel(filename, rows, columns);
      toast(t('Export ready'));
    } catch (e) {
      toast(e.message || t('Export failed'), { tone: 'error' });
    } finally {
      setBusy(false);
    }
  }

  return (
    <button type="button" className="btn ghost sm" onClick={onClick} disabled={disabled || busy}>
      {busy ? t('Exporting…') : t('Export Excel')}
    </button>
  );
}
